import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { deepClone, trackByIndex } from '@blaze-shared/shared-util';
import { type ColorPalette } from '@blaze-shared/theming-domain';

@Component({
  selector: 'blaze-color-palette-bar',
  templateUrl: './color-palette-bar.component.html',
  styleUrls: ['./color-palette-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ColorPaletteBarComponent implements OnChanges {
  @Input() palette?: ColorPalette;
  @Input() allowEdit? = false;
  @Input() hideForeColor? = false;
  @Output() colorChange = new EventEmitter<ColorPalette>();

  colors: string[] = [];

  trackByIndexFn = trackByIndex;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['palette']) {
      this.colors = this.palette
        ? this.hideForeColor
          ? [...this.palette.bg]
          : [this.palette.fg, ...this.palette.bg]
        : [];
    }
  }

  onColorChange(color: string, index: number): void {
    if (!this.palette) {
      return;
    }

    const palette = deepClone(this.palette);
    if (index === 0) {
      palette.fg = color;
    } else {
      palette.bg[index - 1] = color;
    }

    this.colorChange.emit(palette);
  }
}
